import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=1acc9aa0&scoped=true&"
import script from "./ContactNote.vue?vue&type=script&lang=js&"
export * from "./ContactNote.vue?vue&type=script&lang=js&"
import style0 from "./ContactNote.vue?vue&type=style&index=0&id=1acc9aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc9aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1acc9aa0')) {
      api.createRecord('1acc9aa0', component.options)
    } else {
      api.reload('1acc9aa0', component.options)
    }
    module.hot.accept("./ContactNote.vue?vue&type=template&id=1acc9aa0&scoped=true&", function () {
      api.rerender('1acc9aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/notes/components/ContactNote.vue"
export default component.exports